var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFibeWaiting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 4,
    fill: "#ECEBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8 26.8H27V21H73.4V26.8H67.6V32.6C67.6 37.2835 65.2336 41.0535 62.2524 44.1333C60.2137 46.2387 57.7342 48.1788 55.2199 50C57.7342 51.8212 60.2137 53.7613 62.2524 55.8667C65.2336 58.9465 67.6 62.7165 67.6 67.4V73.2H73.4V79H27V73.2H32.8V67.4C32.8 62.7165 35.1664 58.9465 38.1476 55.8667C40.1863 53.7613 42.6658 51.8212 45.1801 50C42.6658 48.1788 40.1863 46.2387 38.1476 44.1333C35.1664 41.0535 32.8 37.2835 32.8 32.6V26.8ZM38.6 26.8V32.6C38.6 34.5865 39.354 36.4715 40.8359 38.4H59.5641C61.0431 36.4715 61.8 34.5865 61.8 32.6V26.8H38.6ZM50.2 53.5438C47.1695 55.684 44.4232 57.7227 42.3149 59.9006C41.7901 60.4386 41.2963 61.006 40.8359 61.6H59.5641C59.1036 61.006 58.6098 60.4386 58.0851 59.9006C55.9768 57.7227 53.2305 55.684 50.2 53.5438Z",
    fill: "#514C9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFibeWaiting);
export default __webpack_public_path__ + "static/media/fibeWaiting.9b5a221d9a5865047839c999cb478429.svg";
export { ForwardRef as ReactComponent };